import { watchAddCartItemSaga } from './addCartItem';
import { watchFetchCart } from './fetchCart';

export const cartsSagas = [watchFetchCart(), watchAddCartItemSaga()];
